var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{staticClass:"kst-action",class:_vm.theClass,attrs:{"aria-role":"list","position":"is-bottom-left"}},[_c('button',{staticClass:"button is-outlined",class:_vm.theButtonClass,attrs:{"slot":"trigger"},slot:"trigger"},[_c('b-icon',{attrs:{"icon":_vm.theIcon}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }